/**
 * ── O RELÓGIO — A MARCA DE «TEM HORA MARCADA», NUM LUGAR SÓ ────────────────
 *
 * Ele nasceu em `Lancamento.tsx`, em 24/09/2026, como o glifo do carimbo
 * *Agendado* do cartaz da vitrine. Em 30/09/2026 saiu de lá para um módulo
 * próprio, e a razão não é arrumação: **a agenda passou a desenhar a mesma
 * marca** — o dia em que um curso estreia leva este relógio na célula, na
 * legenda da grade e na linha do dia.
 *
 * As duas alternativas eram piores, e as duas já morderam esta casa:
 *
 * | alternativa | o que ela produz |
 * |---|---|
 * | redesenhar o SVG na agenda | duas silhuetas a divergir no primeiro acerto — e o aluno a não reconhecer na agenda o carimbo que viu na vitrine |
 * | importar de `Lancamento.tsx` | a agenda a arrastar o cartaz, a tranca de ordem e o aviso do topo do curso para dentro do pedaço dela, por quinze linhas de SVG |
 *
 * `Lancamento.tsx` reexporta-o, e por isso **nenhum importador mudou**.
 *
 * Os ponteiros estão parados às 12h10 e não se mexem: um relógio a andar seria
 * movimento por toda a parte e uma promessa de exatidão ao segundo que o
 * servidor não dá. `aria-hidden` porque a palavra ao lado já o diz — e nunca um
 * emoji, pela razão de sempre (emoji muda de forma, de peso e de cor em cada
 * sistema, e este símbolo aparece agora em **três** telas que têm de parecer a
 * mesma).
 */
export function Relogio({ tamanho = 12 }: { tamanho?: number }) {
  return (
    <svg
      width={tamanho}
      height={tamanho}
      viewBox="0 0 12 12"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      aria-hidden
      focusable="false"
    >
      <circle cx="6" cy="6" r="4.4" />
      <path d="M6 3.4V6l1.9 1.1" strokeLinecap="round" />
    </svg>
  );
}
